// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compound-cluster-badge[data-v-fa6a8f44]{padding:4px 12px;border-radius:16px;display:flex;align-items:center;width:-moz-fit-content;width:fit-content;cursor:default}.compound-cluster-badge i[data-v-fa6a8f44]{font-size:16px;margin-right:6px}", ""]);
// Exports
module.exports = exports;
